import { Link, useNavigate } from "react-router-dom";
import { GLOBAL_IMAGES, HEADER } from "../../assets/asset";
import { useSelector } from "react-redux";
import SubscribedBadge from "../subscription/SubscribedBadge";
import { useSubscription } from "../../context/SubscriptionContext";

export default function Header() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { effectiveStatus } = useSubscription();
  const canShowClassBooking =
    effectiveStatus === "trialing" || effectiveStatus === "active";
  console.log("user in header :: ", user);

  function yearStringToNumber(yearStr) {
    if (!yearStr || !yearStr.startsWith("Year ")) {
      return null;
    }

    try {
      const yearNum = parseInt(yearStr.split(" ")[1]);
      return yearNum + 1;
    } catch (error) {
      return null;
    }
  }

  const handleNotebookClick = () => {
    const yearId = yearStringToNumber(user?.year);
    if (yearId) {
      navigate("/lessonDashboard", { state: { yearId } });
    } else {
      console.error("Invalid or missing year data");
    }
  };

  console.log("yearStringToNumber(user.year):", yearStringToNumber(user?.year));

  return (
    <header className="leaderboard-header w-full flex justify-between px-20 pt-3">
      <div className="leaderboard-header-left left flex items-center gap-14">
        <Link to={"/"}>
          <img src={GLOBAL_IMAGES.dingo} className="leaderboard-header-logo h-20 w-auto" alt="" />
        </Link>
        <img
          src={GLOBAL_IMAGES.LoginBackButton}
          className="leaderboard-header-back h-12 w-auto cursor-pointer"
          alt=""
          onClick={() => navigate(-1)}
        />
      </div>

      <div className="leaderboard-header-center flex items-center gap-14 ">
        {/* <img
          src={GLOBAL_IMAGES.notebook}
          className="h-16 w-auto cursor-pointer"
          alt=""
          onClick={handleNotebookClick}
        /> */}
        {/* <Link to={"/badges"} className="relative flex flex-col items-center">
          <img src={GLOBAL_IMAGES.medal} className="h-16 w-auto" alt="" />
          <div className="w-2 h-2 bg-blue-500 rounded-full mt-1"></div>
        </Link> */}
      </div>

      <div className="leaderboard-header-right right flex items-center gap-14">
        {/* {canShowClassBooking && (
          <Link
            to="/classBooking/dashboard"
            className="leaderboard-class-booking inline-flex items-center rounded-md border-[3px] border-[#0B2B66] bg-gradient-to-r from-[#B3F5FF] via-[#7BE1FF] to-[#57C7FF] px-4 py-1.5 shadow-[0_4px_0_#0B2B66]"
            aria-label="Go to class booking"
          >
            <span className="font-extrabold text-[#0B2B66] text-xs md:text-sm uppercase tracking-[0.08em]">
              Class Booking
            </span>
          </Link>
        )} */}
        <SubscribedBadge />
        <Link to={"/report"}>
          <img src={HEADER.ReportCard} className="leaderboard-header-report h-16 w-auto" alt="" />
        </Link>
        <Link to={"/settings"}>
          <img src={user?.profilephotos} className="leaderboard-header-avatar h-20 w-auto" alt="" />
        </Link>
      </div>
    </header>
  );
}
